import { webApi } from '@lib/api'

export const listTag = ({ id }) => webApi({ auth: true }).get(`/v1/site/${id}/tags`)
